import { Add } from '@mui/icons-material';
import { Fab } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { tabRoutes } from '../../constants/hinge-connect-constants.constant';
import { rulesRoutes } from '../constants/rules.constant';

export const CreateRuleFab = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fab
      color="primary"
      size="large"
      aria-label="add-new-rule"
      onClick={(): void =>
        navigate(
          `/${tabRoutes.baseRoute}/${tabRoutes.rules}/${rulesRoutes.new}`,
        )
      }
      sx={{
        position: 'fixed',
        bottom: 32,
        right: 32,
      }}
    >
      <Add />
    </Fab>
  );
};
